export default "__VITE_ASSET__86d6119d__"